module.exports = __webpack_public_path__ + "img/header-logo.ad747537.png";